export enum QuantitativeDecisionStatisticEnum {
    P_95thPercentile = 0,
    P_95thPercentileUCL70 = 1,
    P_95thPercentileUCL90 = 2,
    P_95thPercentileUCL95 = 3,
    ArithmeticMean95UCL = 4
}

export enum QuantitativeDecisionStatisticNamesEnum {
    '95th Percentile' = QuantitativeDecisionStatisticEnum.P_95thPercentile,
    '95th Percentile & 70% UCL' = QuantitativeDecisionStatisticEnum.P_95thPercentileUCL70,
    '95th Percentile & 90% UCL' = QuantitativeDecisionStatisticEnum.P_95thPercentileUCL90,
    '95th Percentile & 95% UCL' = QuantitativeDecisionStatisticEnum.P_95thPercentileUCL95,
    '95% UCL of the Arithmetic Mean' = QuantitativeDecisionStatisticEnum.ArithmeticMean95UCL
}

export enum InitialQualitativeEnum {
    'Start Empty',
    'Copy From'
}